export default {
  index: {
    header: {
      title: 'Express Sale',
      subTitle: 'Get instant cash for your gear',
      werePartneringWith: 'We\'re partnering with retailers who will purchase your eligible gear from you at a cash price. The price you see is the price you\'ll get.',
      noNeedToCalculateHtml: 'No need to calculate shipping costs or fees. All you need to make a sale is an eligible product in at least %{veryGoodLinkOpen}Very Good%{veryGoodLinkClose} condition without any modifications. For more info, check out the %{termsLinkOpen}terms & conditions.%{termsLinkClose}',
      toggleMore: 'Less info',
      toggleLess: 'More info',
    },
    sellCard: {
      cashOfferHtml: '%{boldOpen}%{displayAmount}%{boldClose} cash offer',
      fromShopName: ' from %{shopName}',
      buttonText: 'Sell Instantly',
      notInAHurry: 'Not in a hurry? %{linkOpen}Start a listing%{linkClose}',
      estimatedListingPrice: 'Estimated Listing Price',
    },
  },
  checkout: {
    header: {
      title: 'Express Sale',
      description: 'Get quick cash for your gear - without shipping costs or fees. Simply verify the condition, send it with a free shipping label, and get cash deposited into your bank account.',
    },
    item: {
      sellingForHtml: 'Selling for %{boldOpen}%{value}%{boldClose}',
      uspsLogoAlt: 'USPS Logo',
      upsLogoAlt: 'UPS Logo',
      carrierLogoAlt: 'Shipping Carrier Logo',
      shippingLabelInfo: 'Free %{boldOpen}%{carrier} shipping label%{boldClose} will be provided',
    },
    condition: {
      title: 'Verify your item\'s condition',
      conditionLabel: 'Is your item in at least very good condition?',
      correctConditionLabel: 'Yes, my item is in very good condition or better.',
      conditionBulletOne: 'Very Good items are fully functional and overall in great condition.',
      conditionBulletTwo: 'There may be a few marks, scratches, or minor blemishes as long as they do not affect the playability or function.',
      incorrectConditionLabel: 'No, my item is not in very good condition.',
      conditionError: 'We\'re sorry, but your item does not qualify for Express Sale. It must be in at least very good condition.',
      modificationsLabel: 'Have you made any modifications?',
      isUnmodifiedLabel: 'No, my item is in its original state.',
      modificationsInfo: '%{boldOpen}Note: %{boldClose}Minor maintenance repairs are good and don’t count as modifications. We won’t accept heavily repaired items or major modifications.',
      isModifiedLabel: 'Yes, I have made modifications.',
      modificationsError: 'We\'re sorry, but your item does not qualify for Express Sale. We don’t accept heavily modified items.',
      helpIconAlt: 'Condition Information Icon',
      beHonest: 'Be honest about the condition of the item you’re selling.',
      beHonestBulletOne: 'When we receive it in the mail, we’re going to verify it is fully functional and has not been modified.',
      beHonestBulletTwo: 'If the condition is not up to our standards, you will not receive the payout amount and you will have to pay for the shipping to the warehouse and return shipping.',
    },
    shipping: {
      title: 'What is your address?',
      description: 'Your address will be used on the free shipping label that we will provide.  If there are any issues with the item\'s condition, we will return it to this address.',
      addNew: 'Add New Address',
      addNewAriaLabel: 'Add new address',
      usePrimary: 'Use Primary Address',
      usePrimaryAriaLabel: 'Use primary address',
      onlyUsCon: 'We currently only allow express sale in the continental United States.',
    },
    terms: {
      title: 'Do you accept our Terms & Conditions?',
      list: {
        first: 'You will receive your payment when we receive your item and verify that it is in at least Very Good Condition and has not been modified.',
        second: 'If your item does not meet our requirements, you will not be paid and you will be responsible for the cost of shipping to the warehouse and return shipping.',
        third: 'You must ship within 5 days.',
        fourthHtml: 'You must have a bank account added in your %{linkOpen}shop settings%{linkClose} to receive your payment.',
      },
      checkboxLabel: 'I accept the Express Sale Terms & Conditions',
    },
    footer: {
      button: 'Make an express sale',
    },
  },
};
